// extracted by css-extract-rspack-plugin
export default {"modal":"Modal__modal--GbbKU","header":"Modal__header--eTE_F","body":"Modal__body--m0F8T","footer":"Modal__footer--uRxPG"};